const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailBlast(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.7,2.6H4.3A2.343,2.343,0,0,0,1.963,4.943v9.41A2.341,2.341,0,0,0,4.3,16.69H6.013a.627.627,0,1,0,0-1.254H4.3a1.084,1.084,0,0,1-1.083-1.083V4.943A1.084,1.084,0,0,1,4.3,3.86H19.7a1.084,1.084,0,0,1,1.083,1.083v9.41A1.084,1.084,0,0,1,19.7,15.436H17.987a.627.627,0,1,0,0,1.254H19.7a2.341,2.341,0,0,0,2.339-2.337V4.943A2.343,2.343,0,0,0,19.7,2.6Z",
    style: {
      fill: "#47b3b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8,4.322a.639.639,0,0,0-.466.113l-6.645,4.8a1.155,1.155,0,0,1-1.371,0L4.67,4.435a.628.628,0,1,0-.736,1.017l6.646,4.8a2.419,2.419,0,0,0,2.841,0l6.646-4.8a.629.629,0,0,0-.27-1.13Z",
    style: {
      fill: "#47b3b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.858,14.8a.632.632,0,0,0,.444.182.623.623,0,0,0,.443-.183l4.277-4.278a.628.628,0,0,0-.888-.887L3.858,13.909a.617.617,0,0,0-.184.443A.629.629,0,0,0,3.858,14.8Z",
    style: {
      fill: "#47b3b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.977,9.633a.629.629,0,0,0,0,.887L19.255,14.8a.627.627,0,0,0,1.07-.446.62.62,0,0,0-.183-.443L15.865,9.632A.628.628,0,0,0,14.977,9.633Z",
    style: {
      fill: "#47b3b0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,12.491A4.428,4.428,0,1,0,15.078,20.1a.539.539,0,0,0-.75-.775,3.349,3.349,0,1,1,1.021-2.407c0,.87-.194,1.017-.627,1.017-.156,0-.627,0-.627-1.017a2.12,2.12,0,1,0-.644,1.5,1.533,1.533,0,0,0,1.271.6c1.131,0,1.705-.705,1.705-2.1A4.433,4.433,0,0,0,12,12.491Zm0,5.444a1.017,1.017,0,1,1,1.016-1.017A1.017,1.017,0,0,1,12,17.935Z",
    style: {
      fill: "#f1b426"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailBlast);
export default __webpack_public_path__ + "static/media/email_blast.f7e9be6b3ca18c99e672df541524288c.svg";
export { ForwardRef as ReactComponent };